module.exports = __webpack_public_path__ + "static/img/1.04b932b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/1.png
// module id = k+yV
// module chunks = 13